import { css } from "styled-components";
import { styled } from "../../../../styled-components";

interface Props {
    orientation: "left" | "right";
}

interface WrapperProps extends Props {
    isFromSameAuthor: boolean;
    useBottomMargin: boolean;
    userCircleSize: number;
}

export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    align-items: flex-end;

    flex-direction: ${p => (p.orientation === "right" ? "row" : "row-reverse")};

    margin: ${p => (p.useBottomMargin ? `5px 0` : "5px 0 30px")};
    ${p =>
        p.isFromSameAuthor &&
        css`
            padding-${p.orientation}: ${p.userCircleSize}px;
        `};
`;

export const BubbleWrapper = styled.div<Props>`
    margin: 0 8px;
    flex-grow: 1;

    display: flex;

    justify-content: ${p => (p.orientation === "right" ? "flex-end" : "flex-start")};
    position: relative;
`;

export const SelectionCircle = styled.div<{ selected: boolean }>`
    width: 24px;
    height: 24px;

    flex-shrink: 0;
    flex-grow: 0;

    margin: 0 4px;

    color: ${p => p.theme.baseColor};

    background-color: ${p => (p.selected ? p.theme.primaryAccentColor : "transparent")};

    ${p => !p.selected && `border: 2px solid ${p.theme.fgColorMedium};`}

    border-radius: 12px;

    display: flex;

    align-items: center;
    justify-content: center;

    transition: background-color 0.2s, border 0.2s;
`;

export const Bubble = styled.div<Props>`
    border-radius: 20px;
    overflow: hidden;
    padding: 12px;
    ${p => p.theme.fontStyles.Body4};

    position: relative;

    word-break: break-word;

    border-bottom-left-radius: ${p => (p.orientation === "left" ? "0" : "20")}px;
    border-bottom-right-radius: ${p => (p.orientation === "right" ? "0" : "20")}px;

    background-color: ${p => (p.orientation === "left" ? p.theme.offBaseColor : p.theme.primaryAccentColor)};
    color: ${p => (p.orientation === "left" ? p.theme.fgColorDark : p.theme.baseColor)};

    a {
        color: ${p => (p.orientation === "left" ? p.theme.linkColor : p.theme.baseColor)};
        text-decoration: underline !important;

        :hover {
            color: ${p => (p.orientation === "left" ? p.theme.linkColor : p.theme.baseColor)};
            text-decoration: underline !important;
        }
    }

    img {
        width: calc(100% + 24px);
        min-width: 100px;
        margin: 8px -12px;

        :last-child {
            margin-bottom: -12px;
        }

        :first-child {
            margin-top: -12px;
        }
    }

    img + br {
        display: none;
    }
`;

export const UserName = styled.div`
    position: absolute;
    color: ${p => p.theme.fgColorLight};
    bottom: -2px;
    transform: translateY(100%);
    ${p => p.theme.fontStyles.Body6}
`;

export const Spacer = styled.div`
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`;
